<template>
  <div>
    <div class="airlines-pricelist-future" v-if="!isModalLoading">
      <adx-table :items.sync="items" :isEmpty.sync="isEmpty"></adx-table>
    </div>
    <a-loading v-else/>
  </div>
</template>

<script>
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"
import moment from 'moment'

import table from '@/components/Table'

import { ALoadingPrimary } from "ui-kit-v1"

export default {
  name: 'adx-airport-placement-future',
  components: {
    'adx-table': table,
    'a-loading': ALoadingPrimary,
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      items: {
        head: [
          {
            title: "START ON",
            type: "text"
          },
          {
            title: "BOTTOM PRICE",
            type: "money"
          },
          {
            title: "PUBLIC PRICE",
            type: "money"
          }
        ],
        body: []
      },
      isEmpty: false,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isModalLoading = true
      this.isEmpty = false
      const { data, status } = await api.get(restEdge.airlinesPlacement(this.placementId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        this.items.body = data.airlinesFuturePrice.map(future => ({
          values: [
            {
              value: moment(future.start).utcOffset(7).format('DD MMM YYYY')
            },
            {
              value: future.bottomPrice
            },
            {
              value: future.publicPrice
            }
          ]
        }))

        if (!this.items.body.length) this.isEmpty = true
      }

      this.isModalLoading = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
.airlines-pricelist-future {
  table {
    tbody {
      tr {
        td {
          .money {
            text-align: left !important;
          }
        }
      }
    }
  }
}
</style>